module.exports = __webpack_public_path__ + "static/media/github.b30f8f2b.svg";